<template>
  <rect
    v-for="(value, index) in filterData"
    :x = "getPointX(index)"
    :y = "getPointY(index)"
    :width = "Math.max(radius * 2, 0)"
    :height = "radius * 2"
    :fill = "getColor"
    :opacity = "getOpacity(index)"
    :rx = "type === 'pressure' ? radius : 0"
    :ry = "type === 'pressure' ? radius : 0"
  />
  <line
    v-for="(value, index) in filterData.slice(0,-1)"
    :x1 = "getPointX(index) + radius"
    :x2 = "getPointX(index + 1) + radius"
    :y1 = "getPointY(index) + radius"
    :y2 = "getPointY(index + 1) + radius"
    :opacity = "getOpacity(index, 'line')"
    :style = "'stroke: ' + getColor"
  />
  <rect
    v-for="(value, index) in filterData"
    :x = "getPointX(index) - (radius * 3)"
    :y = "getPointY(index) - (radius * 3)"
    :width = "Math.max(radius * 8, 0)"
    :height = "radius * 8"
    :opacity = "0"
  >
    <title>
      {{ tooltipFor(value) }}
    </title>
  </rect>
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSegmentStore } from '@/store/SegmentStore';
import { useSettingsStore } from '@/store/SettingsStore';

export default {
  name: 'Points',
  props: [
    'data',
    'type'
  ],
  data () {
    return {
      radius: 6,
      posY: 10
    };
  },
  computed: {
    getColor () {
      return this.$props.type === 'pressure' ? 'var(--pressure-color)' : 'var(--flow-color)';
    },
    filterData () {
      return this.$props.data;
    },
  },
  methods: {
    getPointX (index) {
      return this.filterData[index].xPosition * useSegmentStore().getMagScale + (useInputStore().getXAxisGap - this.radius); 
    },
    getPointY (index) {
      let value = this.filterData[index];
      if (value === undefined) { return; }
      let rv = this.$props.type === 'pressure' ? value.sprinklerPressure : value.nozzleFlow;
      const y = useInputStore().mapMinMaxRange(rv, this.$props.type) - this.radius;
      return Number.isFinite(y) ? y : 0;
    },
    getOpacity (index, type) {
      if (this.filterData[index].nozzleId === null) { return 0; }
      let next = this.filterData[index + 1];
      if (next !== undefined && next.nozzleId === null && type === 'line') {
        return 0;
      } else {
        return 1;
      }
    },
    tooltipFor (value) {
      const settingsStore = useSettingsStore();
      if (this.$props.type == 'pressure') {
        return 'Pressure: ' + Math.round(settingsStore.filterPressure(value.sprinklerPressure) * 100) / 100;
      } else {
        return 'Flow: ' + Math.round(settingsStore.filterEmitterFlow(value.nozzleFlow) * 100) / 100;
      }
    }
  }
};
</script>